// GoTaps — User Edit / NFC Data

export const LINK_TYPES = [
  {type:"linkedin",  label:"LinkedIn",    ico:"💼", color:"#0a66c2"},
  {type:"instagram", label:"Instagram",   ico:"📸", color:"#e1306c"},
  {type:"facebook",  label:"Facebook",    ico:"👥", color:"#1877f2"},
  {type:"twitter",   label:"Twitter / X", ico:"🐦", color:"#000000"},
  {type:"youtube",   label:"YouTube",     ico:"▶️", color:"#ff0000"},
  {type:"tiktok",    label:"TikTok",      ico:"🎵", color:"#010101"},
  {type:"website",   label:"Website",     ico:"🌐", color:"#18181b"},
  {type:"email",     label:"Email",       ico:"📧", color:"#64748b"},
  {type:"phone",     label:"Phone",       ico:"📞", color:"#059669"},
  {type:"whatsapp",  label:"WhatsApp",    ico:"💬", color:"#25d366"},
  {type:"calendly",  label:"Calendly",    ico:"📅", color:"#006bff"},
  {type:"venmo",     label:"Venmo",       ico:"💸", color:"#008cff"},
  {type:"paypal",    label:"PayPal",      ico:"🅿️", color:"#003087"},
  {type:"github",    label:"GitHub",      ico:"🐱", color:"#24292e"},
];

export const WALLPAPERS = [
  "linear-gradient(145deg,#0c4a6e,#0891b2,#06b6d4)",
  "linear-gradient(145deg,#064e3b,#059669,#34d399)",
  "linear-gradient(145deg,#1e1b4b,#6d28d9,#a78bfa)",
  "linear-gradient(145deg,#78350f,#d97706,#fbbf24)",
  "linear-gradient(145deg,#7f1d1d,#dc2626,#f87171)",
  "linear-gradient(145deg,#1e293b,#334155,#94a3b8)",
  "linear-gradient(145deg,#0c0a09,#292524,#57534e)",
  "linear-gradient(145deg,#0d4a2e,#15803d,#86efac)",
  "linear-gradient(145deg,#2d1b69,#5b21b6,#c4b5fd)",
  "linear-gradient(145deg,#831843,#be185d,#f9a8d4)",
];

export const CATEGORIES = ["Sales","Marketing","Business Development","Engineering","Design","Finance","Operations","Leadership","Customer Success","Other"];
export const LEAD_FIELDS = [
  {label:"Full Name",    key:"name",         ico:"👤", required:true},
  {label:"Email",        key:"email",        ico:"📧", required:true},
  {label:"Phone Number", key:"phone",        ico:"📞", required:true},
  {label:"Company",      key:"company",      ico:"🏢", required:true},
  {label:"Job Title",    key:"job_title",    ico:"🪪", required:true},
  {label:"Country",      key:"country",      ico:"🌍", required:false},
  {label:"State",        key:"state",        ico:"📍", required:false},
  {label:"City",         key:"city",         ico:"🏙", required:false},
  {label:"Address",      key:"address",      ico:"📮", required:false},
  {label:"Website",      key:"website",      ico:"🌐", required:false},
  {label:"LinkedIn URL", key:"linkedin_url", ico:"💼", required:false},
  {label:"Note",         key:"note",         ico:"📝", required:false},
  {label:"Message",      key:"message",      ico:"💬", required:false},
];

/* ── Live Popl Card Preview ── */
